import React from "react";
import { Box } from "@mui/material";
import { catalogueStyles } from "./styles";

const Catalogue = () => {
  return <Box sx={catalogueStyles}>Catalogue</Box>;
};

export default Catalogue;
